<template>
  <footer class="flex flex-col py-4 text-center text-slate-500 gap-1">
    <p class="text-sm">
      Mat Consult, spol. s r.o.
    </p>
    <p class="text-xs">
      Copyright © {{ new Date().getFullYear() }}
    </p>
  </footer>
</template>
